export const BOT_INFO = 'BOT_INFO';
export const CARD = 'CARD';
export const DATA = 'DATA';
export const PAUSE = 'PAUSE';
export const REPLY = 'REPLY';
export const SAY = 'SAY';
export const SESSION_TIMEOUT = 'SESSION_TIMEOUT';
export const START = 'START';
export const TEXT = 'TEXT';
export const CALLBACK = 'CALLBACK';
